/* eslint-disable */
// ESSAYQUESTION, // 问答题
// GAPFILLING, // 填空题
// SINGLECHOICE, // 单选题
// MULTIPLECHOICEA, // 多选题A
// MULTIPLECHOICEB, // 多选题B（前端显示不一样）
// FILLBLANKS, // 选择填空题
// TABLEQUESTION, // 表格题
// ligatureQuestion, // 连线题
// determineQuestion, // 判断题
// MATERIALANALYSISPROBLEM, // 材料分析题
// RECTANGULARTOPIC, // 矩形题目
// QUESTIONNAIRESURVEY, // 问卷调查，
// QUALITATIVEINTERVIEWS, // 质性访谈 （少单选题 ）
// // 内容：11
// TEXTAXIS, // 文字—轴型
// VIDEOFILE, // 视频文件
// DIALOGUE, // 人物对话
// ASKANDANSWER, // 提问-回答
// DEPARTMENT, // 部门文件
// UPLOAD,//附件
// INFOBASE, // 资料库
// SINGLETEXT, // 文字一单文本
// PICTURETEXT, // 文字一图文
// CASEGUIDE, // 案例引导语
// HEADLINE, // 标题文字
// MATERIALS, // 材料
// PICTURE, // 图片
// SMALLTITLE  // 小标题
// DataTEXTCONTENT, // 数据-文字内容
// MULTIPLECHOICEQUESTIONS // 多标签矩阵选择题，分页符 11
// 定义一个混入对象
import mybus from "@/utils/main";
const subjectMixin = {
  data() {
    return {
      MX_controlType: [
        "SINGLECHOICE",
        "MULTIPLECHOICEA",
        "MULTIPLECHOICEB",
        "GAPFILLING",
        "ESSAYQUESTION",
        "FILLBLANKS",
        "MATERIALANALYSISPROBLEM",
        "RECTANGULARTOPIC",
        "CASEGUIDE",
        "SINGLETEXT",
        "TEXTAXIS",
        "DIALOGUE",
        "PICTURETEXT",
        "VIDEOFILE",
        "HEADLINE",
        "SMALLTITLE",
        "ASKANDANSWER",
        "INFOBASE",
        "DEPARTMENT",
        "determineQuestion",
        "TABLEQUESTION",
        "ligatureQuestion",
        "CASEUPLOAD",
      ],
    };
  },

  methods: {
    MX_subjectQuery(id, index) {
      // this.$router.go(0)
      if (this.stepIndex === 0) {
        // 首页基础信息重载
        this.Refresh = false;
        setTimeout(() => {
          this.Refresh = true;
        }, 10);
        return;
      }
      console.log(this);
      /** 任务id */
      const taid =
        this.$store.state.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]]
          .task[this.stepIndex - 1].id;
      /** index -> 场景序号 */
      /** index1 -> 任务序号 */
      // 查询场景下的控件
      const data = {
        tsId: id,
        module: this.$store.state.task.modules,
      };
      this.$http.listControlByTsid(data).then((res) => {
        console.log("查询2");
        let data2 = {
          index: this.caseValue[+sessionStorage.getItem("CaseStage") - 1],
          data: res.data.data,
          setIndex: this.stepIndex - 1,
          sceneIndex: index,
          // id: res.data.data.id
        };
        //
        // 切换任务 查询任务下的场景
        const data = {
          taId: taid,
        };
        this.$http.listTaskScenarioByTaid(data).then((res) => {
          const data1 = {
            index: this.caseValue[+sessionStorage.getItem("CaseStage") - 1],
            SceneList: res.data.data,
            setIndex: this.stepIndex - 1,
          };
          this.$store.commit("postTaskScene", data1);
          const data3 = JSON.parse(JSON.stringify(data1));
          this.$store.commit("postTaskScene1", data3);
          this.Refresh = false;
          setTimeout(() => {
            this.taskChange(this.stepIndex - 1, JSON.parse(sessionStorage.getItem("taskInfo")));
            this.Refresh = true;
            this.$store.commit("postSceneControl", data2);
          }, 10);
          mybus.$emit(`add${this.stepIndex - 1}`, res.data.data);
        });
      });
    },
    MX_TYPEINDEX(data) {
      /** 检测控件类型 */
      let index = -1;
      switch (data) {
        case "Single":
          index = 0;
          break;
        case "MultipleA":
          index = 1;
          break;
        case "MultipleB":
          index = 2;
          break;
        case "Fillblank":
          index = 3;
          break;
        case "EasyQuestion":
          index = 4;
          break;
        case "MultipeChoice":
          index = 5;
          break;
        case "Material":
          index = 6;
          break;
        case "CaseGuide":
          index = 8;
          break;
        case "CaseSingleText":
          index = 9;
          break;
        case "CaseAxis":
          index = 10;
          break;
        case "CaseDialogue":
          index = 11;
          break;
        case "CasePhotoText":
          index = 12;
          break;
        case "CaseVideo":
          index = 13;
          break;
        case "CaseTitle":
          index = 14;
          break;
        case "smallCaseTitle":
          index = 15;
          break;
        case "CaseAskAndAnswer":
          index = 16;
          break;
        case "CaseInfoBase":
          index = 17;
          break;
        case "CaseDepartment":
          index = 18;
          break;
        case "determineQuestion":
          index = 19;
          break;
        case "TableQuestion":
          index = 20;
          break;
        case "ligatureQuestion":
          index = 21;
          break;
        case "CaseUpload":
          index = 22;
          break;
      }
      return this.MX_controlType[index];
    },
    async MX_Handle(dataMain, tsId, index99, isUpdate = true) {
      console.log(data);
      console.log(tsId, "tsIdtsIdtsId");
      const addSubject = [];
      const data = JSON.parse(JSON.stringify(dataMain));
      /** 处理新建题目的数据 */
      /** index99-> 场景序号 */
      /** data -> 全部控件列表 */
      /** isUpdate  表示是否上传数据 true为上传 false为不上传*/
      /** pageNumber -> 题目的分页页码 */
      let pageNumber = 0;
      //
      const data2 = data.filter((v) => v.name != undefined);
      data2.forEach(async (element, index) => {
        /** index为控件的顺序下标 */
        // 判断id是否存在 不存在即为创建

        // if (element.data) {
        if (element.name == "CaseInfoBase") {
          await this.$http
            .hanleMaterials(
              this.stepIndex == 0
                ? sessionStorage.getItem("chId")
                : JSON.parse(sessionStorage.getItem("taskInfo")).id || tsId,
              element.data.infoData.map((v) => {
                return {
                  ...v,
                  bizCode: sessionStorage.getItem("isCZJL") == "true" ? "CZJL" : v.bizCode,
                };
              })
            )
            .then((res) => {
              sessionStorage.setItem("isCZJL", false);
            });
        }
        if (element.name == "CaseDepartment") {
          const params = element.data.DeptData.map((item) => {
            return item.childList.map((child) => {
              return {
                bizCode: child.bizCode || "",
                title: child.title || "",
                descr: child.descr || "",
                deptId: item.deptId || "",
                ...child,
              };
            });
          }).flat();
          await this.$http.hanleMaterials(
            this.stepIndex == 0
              ? sessionStorage.getItem("chId")
              : JSON.parse(sessionStorage.getItem("taskInfo")).id || tsId,
            params
          );
        }
        if (element.name === "Divider") {
          addSubject.push({});
          pageNumber++;
          //
        } else {
          console.log(element, "element");
          const data2 = {
            haId:
              this.$store.state.Case.caseData[
                this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
              ].HallId || tsId,
            tsId: tsId,
            hint: element.data.tips ? element.data.tips?.trim() : "",
            id: element.data.id ? element.data.id : "",
            type: this.MX_TYPEINDEX(element.name),
            stem: element.data.stem || null,
            answer:
              typeof element.data.answer != "string"
                ? JSON.stringify(element.data.answer)
                : element.data.answer,
            metas: JSON.stringify(element.data.metas) ? JSON.stringify(element.data.metas) : "",
            isShow: element.data.isShow ? true : false,
            analysis: element.data.analysis ? element.data.analysis.trim() : "",
            scoringKeywords: element.data.scoringKeywords
              ? JSON.stringify(element.data.scoringKeywords)
              : "",
            score: element.data.score ? element.data.score : "0",
            pageNumber: pageNumber,
            title: element.data.title ? element.data.title : "",
            controlSequenceNumber: index,
            infoData: element.data.infoData || [],
            DeptData: element.data.DeptData || [],
            module: this.$store.state.task.modules || "",
            extend: JSON.stringify(element.data.extend || []),
            // image: element.data.image ? element.data.image : ""
          };
          console.log(data2, "data2的最终");
          addSubject.push(data2);
        }
        // }

        //
      });
      /** addSubject 获取到全部的新增数据 */
      //
      /** 验证是否有没填的数据 */
      let Boer = true;
      /** Boer -> 用来验证题目是否通过效验 */
      for (const item of addSubject) {
        switch (item.type) {
          case "SINGLECHOICE":
            /** 单选题验证 */
            if (!item.analysis || !item.stem || !item.answer) {
              this.$Message.error(`请填写完成单选题!`);
              Boer = false;
            } else {
              for (let index = 0; index < JSON.parse(item.metas).length; index++) {
                const element = JSON.parse(item.metas)[index];
                if (!element) {
                  this.$Message.error(`请填写完成单选题!`);
                  Boer = false;
                }
              }
            }
            break;
          case "MULTIPLECHOICEA":
            /** 多选题验证 */
            console.log(item, "iemiemiemiem");
            // if (!item.analysis || !item.stem) {
            //   this.$Message.error(`请填写完成多选题1!`);
            //   Boer = false;
            // } else {
            //   if (JSON.parse(item.answer).length === 0) {
            //     this.$Message.error(`请选择多选题答案!`);
            //     Boer = false;
            //   }
            //   for (let index = 0; index < JSON.parse(item.metas).length; index++) {
            //     const element = JSON.parse(item.metas)[index];
            //     if (!element) {
            //       this.$Message.error(`请填写完成多选题2!`);
            //       Boer = false;
            //     }
            //   }
            // }
            break;
          case "MULTIPLECHOICEB":
            /** 多选题验证 */
            if (!item.analysis || !item.stem) {
              this.$Message.error(`请填写完成多选题!`);
              Boer = false;
            } else {
              if (JSON.parse(item.answer).length === 0) {
                this.$Message.error(`请选择多选题答案!`);
                Boer = false;
              }
              for (let index = 0; index < JSON.parse(item.metas).length; index++) {
                const element = JSON.parse(item.metas)[index];
                if (!element) {
                  this.$Message.error(`请填写完成多选题!`);
                  Boer = false;
                }
              }
            }
            break;
          case "GAPFILLING":
            /** 填空题验证 */
            if (!item.analysis || !item.stem) {
              this.$Message.error(`请填写完成填空选题!`);
              Boer = false;
            } else {
              if (JSON.parse(item.scoringKeywords).length === 0) {
                this.$Message.error(`请填写完成填空选题评分关键字或参考答案!`);
                Boer = false;
              }
            }
            break;
          case "ESSAYQUESTION":
            /** 问答题验证 */
            if (!item.analysis || !item.stem || !item.metas) {
              this.$Message.error(`请填写完成问答题!`);
              Boer = false;
            } else {
              if (JSON.parse(item.scoringKeywords).length === 0) {
                this.$Message.error(`请填写完成问答题评分关键字!`);
                Boer = false;
              }
            }
            break;
          case "FILLBLANKS":
            /** 选择填空题验证 */
            if (!item.analysis || !item.stem || !item.metas) {
              this.$Message.error(`请填写完成选择填空题!`);
              Boer = false;
            } else {
              if (JSON.parse(item.answer).length === 0) {
                this.$Message.error(`请填写完成选择填空题!`);
                Boer = false;
              }
            }
            break;
          case "TABLEQUESTION":
            /** 选择表格题验证 */
            if (!item.stem || !item.metas) {
              this.$Message.error(`请填写完成表格题!`);
              Boer = false;
            }
            break;
          case "ligatureQuestion":
            /** 选择连线题验证 */
            if (!item.stem || !item.metas) {
              this.$Message.error(`请填写完成选择填空题!`);
              Boer = false;
            }
            break;
          case "determineQuestion":
            /** 改错题 */
            console.log("item", item);
            const filledSection = !!item.extend
              ? JSON.parse(item.extend).every((item) => {
                  return !!item.title && !!item.editorContent;
                })
              : false;
            console.log(
              "🚀 ~ filledSection ~ filledSection:",
              !filledSection || !item.stem || !item.metas,
              filledSection,
              item.stem,
              item.metas
            );

            if (!filledSection || !item.stem || !item.metas) {
              this.$Message.error(`请填写完成改错题!`);
              Boer = false;
            }
            break;
          case "MATERIALANALYSISPROBLEM":
            /** 材料题验证 */
            if (!item.analysis || !item.stem || !item.metas || !item.answer) {
              this.$Message.error(`请填写完成材料题!`);
              Boer = false;
            } else {
              if (JSON.parse(item.scoringKeywords).length === 0) {
                this.$Message.error(`请填写完成材料题!`);
                Boer = false;
              }
            }
            break;
          case "CASEGUIDE":
            /** 案例引导验证 */
            if (!item.stem || !item.title) {
              this.$Message.error(`请填写完成案例引导!`);
              Boer = false;
            }
            break;
          case "SINGLETEXT":
            /** 文字-单文字验证 */
            if (!item.stem || !item.title) {
              this.$Message.error(`请填写完成案例引导!`);
              Boer = false;
            }
            break;
          case "TEXTAXIS":
            /** 轴形验证 */
            if (!item.stem) {
              this.$Message.error("请填写完成文字-轴形");
              Boer = false;
            } else {
              if (JSON.parse(item.metas).length === 0) {
                this.$Message.error("请填写完成文字-轴形");
                Boer = false;
              }
            }
            break;
          case "DIALOGUE":
            /** 人物对话 */
            if (JSON.parse(item.metas).length === 0) {
              this.$Message.error("请填写完成人物对话");
              Boer = false;
            }
            break;
          case "ASKANDANSWER":
            /** 人物对话 */
            // console.log(item, "item");
            if (JSON.parse(item.metas).length === 0) {
              this.$Message.error("请填写完成提问-回答");
              Boer = false;
            }
            break;
          case "DEPARTMENT":
            /** 部门文件 */
            console.log(item, "ii");
            const params = item.DeptData;
            if (params.some((v) => v.deptId == "")) {
              this.$Message.error("请填写完成部门文件");
              Boer = false;
              return;
            }
            for (let index = 0; index < params.length; index++) {
              if (params[index].childList.some((v) => v.content == "" || v.title == "")) {
                this.$Message.error("请填写完成部门文件");
                Boer = false;
                break;
              }
            }
            break;
          case "INFOBASE":
            /** 资料库 */
            if (item.infoData.some((v) => v.title == "" || v.content == "")) {
              this.$Message.error("请填写完成资料库");
              Boer = false;
            }
            break;
          case "HEADLINE":
            /** 标题 */
            if (!item.title) {
              this.$Message.error("请填写完成标题填写");
              Boer = false;
            }
            break;
          default:
            console.log(item.type);
            console.sun(item.type);
            break;
        }
      }

      if (Boer) {
        /** 如果所有控件通过效验 */
        await this.$http
          .batchDeletingControl({
            ids: JSON.stringify(this.$store.state.task.deleteControl),
          })
          .then((res) => {
            /** 先删除 再添加或修改 */
            if (addSubject.length === 0) {
              this.$Spin.hide(); // 关闭加载中
              this.$Message.success("保存成功！");
            }
            let state = false;
            let idx = 0;
            addSubject.forEach((res1, index) => {
              console.log(res1, "res11111");
              let data = new FormData();
              if (res1.type == "TABLEQUESTION") {
                let arr = [];
                JSON.parse(res1.metas).forEach((v) => {
                  if (v.children) {
                    v.children.forEach((val) => {
                      if (val.children) {
                        arr = arr.concat(val.children);
                      }
                    });
                    // arr = v.children.map(val => val.children).map((item, i) => item[i]) || [];
                  }
                });
                let sum = arr
                  .map((v) => v.weight)
                  .reduce((accumulator, currentValue) => {
                    return accumulator + currentValue.fraction;
                  }, 0);
                if (sum > 100) return this.$Message.error("请确保权重数值在参考答案区间!");
              }
              if (this.stepIndex === 0) {
                if (this.$refs.IndexHome.$refs[`indexhome${index}`][0]?.type === "上传") {
                  data.append("image", this.$refs.IndexHome.$refs[`indexhome${index}`][0].file);
                }
              } else {
                // console.log(this.$refs[`task${this.stepIndex}`])
                const arr =
                  this.$refs[`task${this.stepIndex}`][0].$refs[`taskIndex${index99}`][0].$refs;
                for (const iterator of Object.keys(arr)) {
                  if (arr[iterator].length !== 0) {
                    if (iterator === `CasePhotoText${index}`) {
                      console.log(arr[iterator], arr);
                      data.append("image", arr[iterator][0].file);
                    } else if (iterator === `CaseVideo${index}`) {
                      data.append("image", arr[iterator][0].file);
                    }
                  }
                }
              }
              filterEmpty(res1);
              for (const key in res1) {
                data.append(key, res1[key]);
                //
              }
              console.log(data.get("type"));
              if (data.get("type") === null) {
                return;
              }
              if (isUpdate && res1.type != "INFOBASE" && res1.type != "DEPARTMENT") {
                console.log(data.get("metas"), "ddddd");
                this.$http.createOrUpdateControl(data).then((res) => {
                  if (res.data.success) {
                    idx += 1;
                    this.$store.commit("emptyDeleteControlList"); // 保存成功之后 清空掉要删除掉的控件ID
                    // this.$router.go(0)
                    // if (addSubject.length - 1 === index) {
                    //   this.MX_subjectQuery(tsId, index99);
                    // }
                    this.MX_subjectQuery(tsId, index99);
                    if (idx === addSubject.length) {
                      this.$Spin.hide(); // 关闭加载中
                      this.$Message.success("保存成功！");
                    }
                  }
                });
              }
            });
          });
      }

      // setTimeout(() => {
      // }, 3000)
    },
  },
};
export default subjectMixin;

/**
 * 把所有undefined处理为空字符串
 **/
function filterEmpty(data) {
  for (const key in data) {
    if (data[key] === undefined) {
      data[key] = "";
    }
  }
}
